import { Link } from 'react-router-dom';
import { Container } from './container';
import { Logo } from '@/components/common/logo';
import { LAUNCH_CATEGORIES } from '@visualry/shared';

const CURRENT_YEAR = new Date().getFullYear();

export const Footer = () => {
  const topCategories = LAUNCH_CATEGORIES.slice(0, 8);
  return (
    <footer className="border-t border-border-subtle bg-surface">
      <Container size="xl" className="py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1 space-y-3">
          <Logo size="md" />
          <p className="text-sm text-text-muted max-w-xs leading-relaxed">
            A premium visual library of AI-generated images and the prompts behind them.
          </p>
          <div className="flex flex-wrap gap-2">
            {['Discover', 'Reveal', 'Generate'].map((item) => (
              <span key={item} className="studio-chip rounded-full px-2.5 py-1 text-xs">
                {item}
              </span>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-text-muted mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/explore" className="text-text-secondary hover:text-foreground">
                All prompts
              </Link>
            </li>
            <li>
              <Link to="/categories" className="text-text-secondary hover:text-foreground">
                All categories
              </Link>
            </li>
            <li>
              <Link to="/guides" className="text-text-secondary hover:text-foreground">
                Guides
              </Link>
            </li>
            {topCategories.slice(0, 10).map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="text-text-secondary hover:text-foreground"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-text-muted mb-3">Product</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/pricing" className="text-text-secondary hover:text-foreground">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/credits" className="text-text-secondary hover:text-foreground">
                Credits usage
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-text-secondary hover:text-foreground">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/generate" className="text-text-secondary hover:text-foreground">
                Generate
              </Link>
            </li>
            <li>
              <Link to="/saved" className="text-text-secondary hover:text-foreground">
                Saved
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-text-muted mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/terms" className="text-text-secondary hover:text-foreground">
                Terms
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="text-text-secondary hover:text-foreground">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" className="text-text-secondary hover:text-foreground">
                Refund policy
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-text-secondary hover:text-foreground">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </Container>
      <div className="border-t border-border-subtle">
        <Container
          size="xl"
          className="py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-text-muted"
        >
          <span>
            Visualry &copy; {CURRENT_YEAR} Quadri LLC. All rights reserved.
          </span>
        </Container>
      </div>
    </footer>
  );
};
